export default function checkFileExtension(filename, extension) {
    var regex = new RegExp('.' + extension + '$', 'ig');
    return regex.test(filename);
  };